import { render, staticRenderFns } from "./Product-barcode.vue?vue&type=template&id=3f66ad97"
import script from "./Product-barcode.vue?vue&type=script&lang=js"
export * from "./Product-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports